var map = {
	"./about_arrow.png": 8093,
	"./bg_color.png": 60019,
	"./business_flow.png": 21657,
	"./business_flow_active.png": 7684,
	"./center_warehouse_icon.png": 553,
	"./customer_case_bg.png": 60505,
	"./customer_case_main.png": 14379,
	"./data_manage.png": 83086,
	"./data_manage_icon.png": 13928,
	"./dispatching_manage.png": 74282,
	"./dispatching_manage_icon.png": 18724,
	"./finance_bg.png": 86046,
	"./finance_hiboos.png": 90885,
	"./finance_hiboos_active.png": 4920,
	"./finance_manage_icon.png": 42988,
	"./finance_purchase.png": 1798,
	"./finance_purchase_active.png": 40157,
	"./finance_right.png": 53745,
	"./finance_sales_channel.png": 54043,
	"./finance_sales_channel_active.png": 10334,
	"./front_warehouse.png": 32017,
	"./front_warehouse_long.png": 23780,
	"./goods_manage.png": 45590,
	"./goods_manage_icon.png": 29472,
	"./join_in.png": 74566,
	"./join_in_center.png": 95752,
	"./join_in_center_active.png": 4687,
	"./join_in_icon.png": 31152,
	"./join_in_left.png": 144,
	"./join_in_left_active.png": 97927,
	"./join_in_right.png": 83109,
	"./join_in_right_active.png": 57080,
	"./manage_pain_point.png": 25163,
	"./oneWare_threeMore.png": 62497,
	"./oneWare_threeMore_icon.png": 59717,
	"./order_manage.png": 11792,
	"./order_manage_icon.png": 50638,
	"./partner.png": 78162,
	"./partner_ddj.png": 23933,
	"./partner_dmcw.png": 88896,
	"./partner_hncw.png": 30843,
	"./partner_jwwh.png": 77619,
	"./partner_ldcw.png": 59153,
	"./partner_lyyyt.png": 59770,
	"./partner_sgx.png": 43549,
	"./partner_st.png": 56106,
	"./partner_wklg.png": 82162,
	"./partner_xbz.png": 47355,
	"./partner_xcsh.png": 96433,
	"./partner_xgyx.png": 2475,
	"./partner_yxg.png": 43009,
	"./partner_zyyx.png": 32403,
	"./phone_bg_new.png": 24423,
	"./phone_homepage.png": 50053,
	"./phone_mine.png": 57076,
	"./phone_order.png": 15873,
	"./phone_warehouse_manage.png": 88164,
	"./phone_work_platform.png": 27302,
	"./pos_manage.png": 94470,
	"./pos_manage_icon.png": 58736,
	"./purchase_manage.png": 38209,
	"./purchase_manage_icon.png": 17157,
	"./rx_icon_1.png": 37142,
	"./rx_icon_10.png": 17444,
	"./rx_icon_2.png": 27821,
	"./rx_icon_3.png": 1668,
	"./rx_icon_4.png": 95259,
	"./rx_icon_5.png": 46258,
	"./rx_icon_6.png": 11401,
	"./rx_icon_7.png": 56576,
	"./rx_icon_8.png": 83847,
	"./rx_icon_9.png": 12510,
	"./rx_left.png": 15330,
	"./rx_right.png": 39199,
	"./sales_manage_icon.png": 61978,
	"./sales_manage_new.png": 67907,
	"./service_standard_arrow.png": 79235,
	"./service_standard_center.png": 34545,
	"./service_standard_left.png": 54309,
	"./service_standard_right.png": 98182,
	"./shop_manage.png": 73298,
	"./shop_manage_icon.png": 34620,
	"./shop_manage_left.png": 13180,
	"./shop_right_center_new.png": 58266,
	"./shop_right_left_new.png": 82574,
	"./shop_right_right_new.png": 92737,
	"./stock_manage.png": 55474,
	"./stock_manage_icon.png": 6876,
	"./supplier.png": 83370,
	"./supplier_icon.png": 66244,
	"./work_flow.png": 1194,
	"./work_flow_active.png": 3769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28837;